<template>
    <div>
        <buttonlist
                @help="help"
                @opentable="opentable"
                @search="search"
                @reflash="reflash"
                @exps="exps"
                ref="SetBtn"
        ></buttonlist>
        <wTable
                id="xpane-0"
                :data="dataSet"
                :loading="loading"
                queryData="IpoDetailViewInfo"
                :filter_language="['Order_Status_Name','Line_Status_Name','fa_flag']"
                :filter_thousandth="['line_net_unitprice','line_total_unitprice','line_net_amount','line_total_amount','Line_Qty','Receive_Qty',
                'Self_Bad_Qty','Scrap_qty','line_net_amount_cny','line_total_amount_cny','lose_qty','Inv_Receive_Qty']"
                :filter_date="['Plan_Delivery_Date','Create_Date']"
                :header="tableHeader"
                :option="tableOption"
                @handleSelectionChange="handleSelectionChange"
                ref="singleTable"
                :checkflg="false"
        ></wTable>
        <!--<el-table
                :data="dataSet"
                v-loading="loading"
                :highlight-current-row="true"
                show-overflow-tooltip="true"
                border
                stripe
                size="mini"
                :height="tableHeight"
                @selection-change="handleSelectionChange"
                header-row-class-name="headerclass"
                style="width: 100%; margin-top:0px"
                :header-cell-style="$limits.headerClass"
        >
        <el-table-column show-overflow-tooltip prop="IPO_code" :label="$t('getapi[1889]')"></el-table-column>
        <el-table-column show-overflow-tooltip prop="Order_Status_Name" :label="$t('getapi[2701]')"></el-table-column>
        <el-table-column show-overflow-tooltip prop="Vender_Code" :label="$t('getapi[1196]')"></el-table-column>
        <el-table-column show-overflow-tooltip prop="vender_name" :label="$t('getapi[1197]')"></el-table-column>
        <el-table-column show-overflow-tooltip prop="Currency_Code" :label="$t('getapi[1338]')"></el-table-column>
        <el-table-column show-overflow-tooltip prop="Tax_Rate" :label="$t('getapi[1225]')" align="right"></el-table-column>
        <el-table-column show-overflow-tooltip prop="Plan_Delivery_Date" :label="$t('getapi[1601]')"></el-table-column>
        <el-table-column show-overflow-tooltip prop="Create_Person" :label="$t('getapi[410]')"></el-table-column>
        <el-table-column show-overflow-tooltip prop="Create_Date" :label="$t('getapi[409]')"></el-table-column>
        <el-table-column show-overflow-tooltip prop="Audit_Person" :label="$t('getapi[550]')"></el-table-column>
        <el-table-column show-overflow-tooltip prop="Line_No" :label="$t('getapi[1425]')" align="right"></el-table-column>
        <el-table-column show-overflow-tooltip prop="Part_Code" :label="$t('getapi[112]')"></el-table-column>
        <el-table-column show-overflow-tooltip prop="Part_Version" :label="$t('getapi[149]')"></el-table-column>
        <el-table-column show-overflow-tooltip prop="Part_Name" :label="$t('getapi[116]')"></el-table-column>
        <el-table-column show-overflow-tooltip prop="line_net_unitprice" :label="$t('getapi[6753]')" align="right" v-if="authority_showprice"></el-table-column>
        <el-table-column show-overflow-tooltip prop="line_total_unitprice" :label="$t('getapi[6754]')" align="right" v-if="authority_showprice"></el-table-column>
        <el-table-column show-overflow-tooltip prop="line_net_amount" :label="$t('getapi[6755]')" align="right" v-if="authority_showprice"></el-table-column>
        <el-table-column show-overflow-tooltip prop="line_total_amount" :label="$t('getapi[6756]')" align="right" v-if="authority_showprice"></el-table-column>
        <el-table-column show-overflow-tooltip prop="Line_Qty" :label="$t('getapi[3101]')" align="right"></el-table-column>
        <el-table-column show-overflow-tooltip prop="Measure_Unit" :label="$t('getapi[888]')"></el-table-column>
        <el-table-column show-overflow-tooltip prop="Routing_Start_Name" :label="$t('getapi[6699]')"></el-table-column>
        <el-table-column show-overflow-tooltip prop="SO_Code" :label="$t('getapi[4285]')"></el-table-column>
        <el-table-column show-overflow-tooltip prop="Routing_Sequence_No" :label="$t('getapi[573]')" align="right"></el-table-column>
        <el-table-column show-overflow-tooltip prop="Line_Status_Name" :label="$t('getapi[2325]')"></el-table-column>
        <el-table-column show-overflow-tooltip prop="Line_Remark" :label="$t('getapi[1509]')"></el-table-column>
        <el-table-column show-overflow-tooltip prop="Process_Remark" :label="$t('getapi[6702]')"></el-table-column>
        <el-table-column show-overflow-tooltip prop="Receive_Qty" :label="$t('getapi[6757]')" align="right"></el-table-column>
        <el-table-column show-overflow-tooltip prop="Self_Bad_Qty" :label="$t('getapi[6758]')" align="right"></el-table-column>
        <el-table-column show-overflow-tooltip prop="Scrap_qty" :label="$t('getapi[4220]')" align="right"></el-table-column>
        <el-table-column show-overflow-tooltip prop="actual_time" :label="$t('getapi[2705]')"></el-table-column>
        <el-table-column show-overflow-tooltip prop="line_total_amount_cny" :label="$t('getapi[6759]')" align="right" v-if="authority_showprice"></el-table-column>
        <el-table-column show-overflow-tooltip prop="line_net_amount_cny" :label="$t('getapi[6760]')" align="right" v-if="authority_showprice"></el-table-column>
        <el-table-column show-overflow-tooltip prop="lose_qty" :label="$t('getapi[6746]')" align="right"></el-table-column>
        <el-table-column show-overflow-tooltip prop="fa_flag" :label="$t('getapi[6106]')"></el-table-column>
        <el-table-column show-overflow-tooltip prop="Inv_Receive_Qty" :label="$t('getapi[1618]')" align="right"></el-table-column>
        <el-table-column show-overflow-tooltip fixed="right" :label="$t('getapi[6048]')" width="100">
        <template slot-scope="scope">
        <el-button @click.native.prevent="getISS(scope.row)" type="text" size="mini">{{$t('getapi[6761]')}}</el-button>
        </template>
        </el-table-column>
        
        </el-table>-->
        <el-row class="page">
            <el-col :span="18">
                <el-pagination
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :page-sizes="[100, 200, 300, 400]"
                        :page-size="pageSize"
                        :pager-count="5"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="total"
                ></el-pagination>
            </el-col>
            <el-col :span="6">
                <div style="text-align: right;line-height: 30px;color: #545c64;font-size: 95%;">{{$t('getapi[7980]')}}:{{ DbTbNames }}</div>
            </el-col>
        </el-row>
        <serce :isVisible="isVisible" queryData="IpoDetailViewInfo" ref="ser" @getser="serclick"></serce>
        <ctable :isVisible="false" :title="$t('getapi[1040]')" queryData="IpoDetailViewInfo" tabNo="0" ref="ctab"
                @getctab="sortclick"></ctable>
    </div>
</template>

<script>
    import Common from '@/components/Common';
    import Array from '@/components/Array';
    export default {
        name:'wxorderdetail',
        computed: {
            tableOption() {
                return {
                    border: true,
                    height: this.$windowSize.tableHeight3,
                    maxHeight: this.$windowSize.tableHeight3,
                }
            },
            tableHeight(){
                return this.$windowSize.tableHeight3
            }
        },
        data() {
            return {
                tableHeader: [],
                dataSet: [], // 主表数据
                isVisible: false, // 查询列表是否显示
                queryData: [], // 查询数组
                userData: [], // 用户信息
                DbTbNames: '',
                pageIndex: 1, // 当前页
                pageSize: this.$http.getPageSize('wxorderdetail'), // 当前页数据量
                SelectIndexs: 0, //当前页面
                total: 0, // 数据总量
                loading: false, // 主表加载状态
                selectData: [],
                btn:{
                    endIssue: false
                },
                authority_showprice: false,
                scrollTop:0,
            };
        },
        watch: {
            dataSet: function () {
                let that = this
                that.$nextTick(function () {
                    that.$processdata.initForm(0)
                })
            },
        },
        mounted: function() {
            let that = this;
            that.colsort();
            that.userData = sessionStorage.getItem('userData');
            that.PlanTypeArray = Array.methods.getPlanType();
            that.authority();
        },
        activated () {
            let that = this
            setTimeout(() => {
                that.$refs.singleTable.$refs.singleTable.bodyWrapper.addEventListener('scroll', (res) => {
                    that.scrollTop = res.target.scrollTop
                },false)
            }, 5000);
            // 路由跳转回来滚动到离开时的位置
            this.$nextTick(()=> {
                setTimeout(() => {
                    this.$refs.singleTable.$refs.singleTable.bodyWrapper.scrollTop =this.scrollTop;
                }, 13)
            })
        },
        methods: {
            help(){
                this.$refs.SetBtn.showHelp(this.$options.name,this.$t("getapi[1040]"),this.$t("getapi[13]"));
            },
            colsort() {
                let that = this;
                that.$loadviewfields.Fileds('IpoDetailViewInfo', 0, PFileds => {
                    that.tableHeader = PFileds;
                });
            },
            sortclick(val) {
                if (val == 1) {
                    this.colsort();
                }
            },
            // 修改表格顺序
            opentable() {
                this.$refs.ctab.clearInputs(true);
            },
            authority() {
                let that = this;
                if(that.$loadviewfields.isEnableHelp(this.$options.name) == 1){
                    that.$refs.SetBtn.SetOneBtnEnable('help',true);
                }
                that.$refs.SetBtn.SetOneBtnEnable('ctabel', true);
                if (that.$limits.authority('plv4', 31, 1) == 0){
                    that.authority_showprice = false
                } else {
                    that.authority_showprice = true
                }
                //只读权
                if (that.$limits.ReadOnlyRightsView('plv2', 31, 1, that.total)) {
                    if (that.total > 0) {
                        that.$refs.SetBtn.SetButtonEnable('search,refresh,export');
                    } else {
                        that.$refs.SetBtn.SetButtonEnable('search,refresh');
                    }
                }
                //操作权限-查询级别
                var limits = that.$limits.OperationAuthorityView('plv2', 31, 1, that.total);
                // limits说明： 1 查询权限、2 编辑权限、3 删除权限(列表行数>0)、4 删除权限(列表行数<0)
                switch (limits) {
                    case -1:
                        that.$refs.SetBtn.SetButtonEnable('search,refresh');
                        break;
                    case 1:
                        that.$refs.SetBtn.SetButtonEnable('search,refresh,export');
                        break;
                    case -2:
                        that.$refs.SetBtn.SetButtonEnable('search,refresh');
                        break;
                    case 2:
                        that.$refs.SetBtn.SetButtonEnable('search,refresh,export');
                        break;
                    case -3:
                        that.$refs.SetBtn.SetButtonEnable('search,refresh');
                        break;
                    case 3:
                        that.$refs.SetBtn.SetButtonEnable('search,refresh,export');
                        break;
                    default:
                        break;
                }
                that.btnauthority();
            },
            btnauthority(){
                let that = this
                that.btn.endIssue = false
                if(that.selectData.length > 0){
                    that.btn.endIssue = true
                }
            },
            handleSizeChange(val) {
                this.pageSize = val;
                this.$http.savePageSize('wxorderdetail',val)
                this.getView();
                this.authority();
            },
            handleCurrentChange(val) {
                this.pageIndex = val;
                this.getView();
                this.authority();
            },
            // 查询
            search() {
                let that = this;
                that.isVisible = true;
                that.$refs.ser.clearInput(that.isVisible, 'IpoDetailViewInfo');
            },
            //获取查询条件
            serclick(val) {
                this.queryData = val;
                this.pageIndex = 1;
                this.confirmGetView();
            },
            // 确认获取数据
            confirmGetView() {
                let that = this;
                that.pageIndex = 1
                that.isVisible = false;
                that.getView();
            },
            // 数据一览
            getView() {
                let that = this;
                that.loading = true;
                let datac = [];
                for (let i = 0; i < that.queryData.length; i++) {
                    datac.push({
                        query_Condition: that.queryData[i].query_Condition,
                        query_field_type: that.queryData[i].Query_Field_Type,
                        query_field_name: that.queryData[i].Query_Field_Name,
                        query_sort: that.queryData[i].query_sort,
                        row_sign: that.queryData[i].row_sign
                    });
                }
                let token = JSON.parse(that.userData).token;
                let data = {
                    PageIndex: that.pageIndex,
                    PageSize: that.pageSize,
                    SelectIndex: that.SelectIndexs,
                    Param: datac
                };
                that.$http.urlpost('/ISS/Order/IPODetailList', data, function(res) {
                    if (res.Success == 1) {
                        that.dataSet = res.DataContent;
                        that.total = res.Totals;
                        that.loading = false;
                        that.DbTbNames = res.DbTbNames;
                        that.authority();
                    }
                });
            },
            // 刷新
            reflash() {
                let that = this;
                that.getView();
            },
            // 导出
            exps() {
                /*let that = this;
                let datac = [];
                for (let i = 0; i < that.queryData.length; i++) {
                    datac.push({
                        query_Condition: that.queryData[i].query_Condition,
                        query_field_type: that.queryData[i].Query_Field_Type,
                        query_field_name: that.queryData[i].Query_Field_Name,
                        query_sort: that.queryData[i].query_sort,
                        row_sign: that.queryData[i].row_sign
                    });
                }
                let parm = {
                    PageIndex: that.PageIndex,
                    PageSize: that.PageSize,
                    SelectIndex: that.SelectIndex,
                    Ids: '',
                    Param: datac
                };
                that.$refs.SetBtn.SetOneBtnEnable('exps',false);
                that.$http.urlpost('/ISS/Order/IPODetailExportToExecl', parm, function(res) {
                    that.$refs.SetBtn.SetOneBtnEnable('exps',true);
                    if (res.Success == 1) {
                        let hrefurl = Common.Url + res.DataContent.URL;
                        window.open(hrefurl);
                    }
                });*/
                let that = this;
                let datac = [];
                for (let i = 0; i < that.queryData.length; i++) {
                    datac.push({
                        query_Condition: that.queryData[i].query_Condition,
                        query_field_type: that.queryData[i].Query_Field_Type,
                        query_field_name: that.queryData[i].Query_Field_Name,
                        query_sort: that.queryData[i].query_sort,
                        row_sign: that.queryData[i].row_sign
                    });
                }
                let parm = {
                    query_sign: "IpoDetailViewInfo",
                    fromname: that.$t('getapi[1040]'),
                    SelectIndex: 0,
                    MultyVer: that.$processdata.getLanguage(),
                    Param: datac
                };
                that.$processdata.commonExport(parm)
            },
            handleSelectionChange(val){
                let that = this;
                that.selectData = val;
                that.btnauthority()
            },
             // 外协业务图
            getISS(data){
                let that = this;
                that.$store.commit('setSharedParams',data);
                let item = {
                    label: '外协关系图',
                    name: 'issrelation',
                    path: '/issrelation/order',
                    url: '/issrelation/order',
                    icon: 'video-play'
                };
                this.$router.push({ path: '/issrelation/order'});
                this.$store.commit('selectMenu', item);
                this.$limits.cachePage(item)
            },
        }
    };
</script>

<style scoped lang="less">
    table {
        border-collapse: separate;
        border-spacing: 0px 5px;
        td {
            padding-left: 3px;
            white-space: pre;
        }
    }
</style>
